import { siteInfo, heroStats } from '@/mocks/homeData';

export default function Hero() {
  const scrollToSection = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-100/40 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4"></div>
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-accent-100/30 rounded-full blur-3xl translate-y-1/2 -translate-x-1/4"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 max-w-[1400px] mx-auto pt-24 md:pt-28 pb-12 md:pb-20">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-primary-100 text-primary-700 rounded-full text-sm font-medium mb-5">
              <span className="w-2 h-2 bg-primary-500 rounded-full animate-pulse"></span>
              实时更新 · 瓜不停蹄
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-3">
              {siteInfo.name}
              <span className="block text-primary-600 mt-1">{siteInfo.corePositioning}</span>
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 font-heading mb-4">
              {siteInfo.slogan}
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-[640px] mx-auto lg:mx-0 mb-6">
              黑料入口是国内领先的娱乐资讯聚合平台，由资深瓜农团队全天候深入娱乐圈一线，为你汇聚全网最新、最独家的黑料爆料、新瓜速递与深度揭秘。无论是51吃瓜黑料入口一二三，还是免费黑料入口，都能让你第一时间获取一手资讯，畅享最纯粹的吃瓜体验。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-8">
              {heroStats.map((stat) => (
                <div key={stat.label} className="flex items-center gap-2">
                  <div className="w-9 h-9 flex items-center justify-center bg-accent-100 rounded-lg">
                    <i className={`${stat.icon} text-accent-600 text-lg`}></i>
                  </div>
                  <div className="text-left">
                    <div className="text-lg font-bold text-foreground-900">{stat.value}</div>
                    <div className="text-xs text-foreground-500">{stat.label}</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#updates"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('#updates');
                }}
                className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-full hover:bg-primary-600 transition-colors text-center whitespace-nowrap cursor-pointer"
              >
                <i className="ri-flashlight-line mr-2"></i>查看最新快讯
              </a>
              <a
                href="#index"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('#index');
                }}
                className="w-full sm:w-auto px-8 py-3 border-2 border-foreground-300 text-foreground-800 font-medium rounded-full hover:border-foreground-500 hover:text-foreground-950 transition-colors text-center whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line mr-2"></i>浏览专题索引
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[540px] lg:max-w-none">
            <div className="relative">
              <div className="absolute -top-4 -left-4 w-24 h-24 bg-accent-200/80 rounded-2xl -rotate-6"></div>
              <div className="absolute -bottom-4 -right-4 w-20 h-20 bg-primary-200/80 rounded-2xl rotate-12"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Chinese%20entertainment%20news%20media%20collage%20with%20smartphone%20screen%20showing%20gossip%20headlines%2C%20dramatic%20spotlight%20effect%2C%20modern%20newsroom%20aesthetic%2C%20warm%20dramatic%20lighting%2C%20editorial%20photography%20style%2C%20bold%20visual%20composition%2C%20dark%20and%20warm%20tones&width=1080&height=810&seq=hero-main&orientation=landscape"
                alt="黑料入口 - 娱乐爆料平台主视觉"
                className="relative w-full h-auto rounded-2xl object-cover z-10"
                width="1080"
                height="810"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}